// src/theme/theme.ts
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: { main: "#E85D04" },
    secondary: { main: "#FFBA08" },
    success: { main: "#2D6A4F" },
    background: { default: "#FFF8F0" },
    text: { primary: "#2D2D2D", secondary: "#666666" },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h3: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          padding: "12px 24px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 8px rgba(232, 93, 4, 0.1)",
        },
      },
    },
  },
});
